import {
  B_09,
  BANNER_DEFAULTS,
  hideB09Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B09_PLASMIC_PROPS = {
  b09Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_09].heading,
    description: "Main heading (B09 only)",
    hidden: hideB09Props,
  },
  b09Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_09].description,
    description: "Description text (B09 only)",
    hidden: hideB09Props,
  },
  b09PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_09].primaryButtonText,
    description: "Primary button text (B09 only)",
    hidden: hideB09Props,
  },
  b09PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (B09 only)",
    hidden: hideB09Props,
  },
  b09PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (B09 only)",
    hidden: hideB09Props,
  },
  b09PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB09Props(props) ||
      (props.b09PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b09PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b09PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB09Props(props) ||
      (props.b09PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b09PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b09SecondaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_09].secondaryButtonText,
    description: "Secondary button text (B09 only)",
    hidden: hideB09Props,
  },
  b09SecondaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Secondary button link type (B09 only)",
    hidden: hideB09Props,
  },
  b09SecondaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open secondary button in new tab (B09 only)",
    hidden: hideB09Props,
  },
  b09SecondaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB09Props(props) ||
      (props.b09SecondaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b09SecondaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b09SecondaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB09Props(props) ||
      (props.b09SecondaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b09SecondaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b09MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_09].mobileImg,
    description: "Mobile/tablet image (B09 only)",
    hidden: hideB09Props,
  },
  b09DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_09].desktopImg,
    description: "Desktop image (B09 only)",
    hidden: hideB09Props,
  },
  b09ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_09].imageAlt,
    description: "Image alt text (B09 only)",
    hidden: hideB09Props,
  },
};
